module.exports = __webpack_public_path__ + "img/12.927cfc9f.svg";